import { useState, useCallback } from 'react';

export function useLoader(initial = false) {
  const [loader, setLoader] = useState(initial);

  const showLoader = useCallback(() => setLoader(true), []);
  const hideLoader = useCallback(() => setLoader(false), []);
  const toggleLoader = useCallback(() => setLoader(prev => !prev), []);

  return {
    loader,
    setLoader,
    showLoader,
    hideLoader,
    toggleLoader,
  };
}
